import { render, staticRenderFns } from "./v_Ongoing_Chat.vue?vue&type=template&id=52083ca3&scoped=true&"
import script from "./v_Ongoing_Chat.vue?vue&type=script&lang=js&"
export * from "./v_Ongoing_Chat.vue?vue&type=script&lang=js&"
import style0 from "./v_Ongoing_Chat.vue?vue&type=style&index=0&id=52083ca3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52083ca3",
  null
  
)

export default component.exports